// routes
import { SvgColor } from '@mgm/common/components/icons';
// components

const icon = (name: string) => (
  <SvgColor src={`/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: icon('ic_analytics'),
  analytics: icon('ic_charts'),
  calendar: icon('ic_calendar'),
  team: icon('ic_team'),
  commissions: icon('ic_plan'),
  tasklists: icon('ic_checklist'),
  timesheets: icon('ic_timesheets'),
  help: icon('ic_help'),
  settings: icon('ic_settings'),
  orders: icon('ic_commissions'),
  payroll: icon('ic_payroll'),
  inventory: icon('ic_inventory'),
};

const navConfig = [
  {
    items: [
      {
        title: 'dashboard', path: '/dashboard', icon: ICONS.dashboard, value: 'dashboard',
      },
      {
        title: 'team', path: '/team', icon: ICONS.team, value: 'team',
      },
      {
        title: 'timesheets', path: '/timesheets', icon: ICONS.timesheets, value: 'sheets',
      },
      {
        title: 'commissions',
        value: 'commissionPlans',
        path: '/commissions',
        icon: ICONS.orders,
        children: [
          { title: 'commissionPlans', path: '/commissions/plans', value: 'commissionPlans' },
          { title: 'commissionTeams', path: '/commissions/teams', value: 'commissionTeams' },
          { title: 'commissionedSales', path: '/commissions/sales', value: 'commissionPlans' },
        ],
      },
      {
        title: 'analytics',
        value: 'analytics',
        path: '/analytics',
        icon: ICONS.analytics,
        children: [
          { title: 'individualCommissions', path: '/analytics/commission/individual', value: 'analytics' },
          { title: 'teamCommissions', path: '/analytics/commission/teams', value: 'analytics' },
          { title: 'footTraffic', path: '/analytics/dor', value: 'analytics' },
        ],
      },
      {
        title: 'inventory', path: '/inventory', icon: ICONS.inventory, value: 'inventory',
      },
      {
        title: 'schedules',
        path: '/schedules',
        value: 'schedules',
        icon: ICONS.calendar,
        children: [
          { title: 'workSchedule', path: '/schedules/weekly', value: 'schedules' },
          { title: 'calendar', path: '/schedules/monthly', value: 'schedules' },
          { title: 'timeoffs', path: '/schedules/timeoff', value: 'timeoff' },
        ],
      },
      // {
      //   title: 'tasklists', path: '/tasklists', icon: ICONS.tasklists, value: 'tasklists',
      // },
      {
        title: 'payroll', path: '/payroll', icon: ICONS.payroll, value: 'payroll',
      },
      {
        title: 'help', path: '/help', icon: ICONS.help, value: 'help',
      },
    ],
  },
];

export default navConfig;
